<template lang="html">
    <div class="features-list">
        <!-- list all the features -->
        <feature v-for="(f, i) in features" :key="i" :index="i"></feature>

        <v-btn small flat round depressed color="primary" @click="add()" :disabled="$store.state.auth.user.level < 60">
            <v-icon class="mr-2">add_circle</v-icon>
            Ajouter une information
        </v-btn>
    </div>
</template>


<script>
    import Feature  from './Feature'

    export default {
        components: { Feature },

        data() {
            return {
                features: []
            }
        },

        methods: {
            add() {
                this.$store.dispatch('addSingleData', {
                    key: 'features.[]',
                    value: {
                        label:          null,
                        value:          null,
                        is_exportable:  true,
                        product_id:     this.$route.params.id
                    }
                })
            }
        },

        watch: {
            '$store.state.single.data.features'(val) {
                this.features = val
            }
        },

        created() {
            this.features = this.$store.state.single.data.features
        }
    }
</script>


<style lang="stylus" scoped>
    @require '../../../../assets/css/variables'

    div.features-list {
        display: flex
        flex-direction: column

        button {
            margin-top: 1.5rem
            justify-self: center
            font-weight: 600

            & >>> div.btn__content {
                font-size: 1.4rem
                letter-spacing: 0.01rem
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/products/single/features/FeaturesList.vue